import {
  type IndustryVertical,
  resolveIndustryProfile,
} from "~/lib/utils/industry-profile";

/** Legacy marketplaceIndustry → vertical when set explicitly on listing. */
const MARKETPLACE_INDUSTRY_VERTICAL: Partial<Record<string, IndustryVertical>> = {
  dental: "healthcare",
  medical: "healthcare",
  physical_therapy: "healthcare",
  chiropractic: "healthcare",
  legal: "legal",
  home_services: "home_services",
};

export function resolveMarketplaceVertical(opts: {
  sicCode?: string | null;
  marketplaceIndustry?: string | null;
  businessDescription?: string | null;
}): IndustryVertical {
  const industry = opts.marketplaceIndustry?.trim();
  if (industry && industry !== "other") {
    const mapped = MARKETPLACE_INDUSTRY_VERTICAL[industry];
    if (mapped) return mapped;
  }

  return resolveIndustryProfile(opts.sicCode, opts.businessDescription).vertical;
}

/** Tokenized search — every word must appear somewhere in the haystack. */
export function marketplaceAgentMatchesSearch(
  haystackParts: (string | null | undefined)[],
  query: string,
): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return true;
  const haystack = haystackParts.filter(Boolean).join(" ").toLowerCase();
  const tokens = q.split(/\s+/).filter(Boolean);
  return tokens.every((token) => haystack.includes(token));
}

export function marketplaceAgentSearchHaystack(agent: {
  title?: string | null;
  industry?: string | null;
  role?: string | null;
  skills?: string[];
  aiAgent?: { name?: string | null; jobTitle?: string | null } | null;
}): string[] {
  return [
    agent.title,
    agent.aiAgent?.name,
    agent.aiAgent?.jobTitle,
    agent.industry,
    agent.role,
    ...(agent.skills ?? []),
  ];
}
